<script>
import options from './CreateEvent.options'
export default options
</script>

<template>
  <article class="kb-create-event">
    <article class="kb-stafet-flow-title">

      <h1 class="kb-stafet-flow-title__title">{{ userInfo ? getLabel('editTitle') : getLabel('title') }}</h1>

      <div class="kb-stafet-flow-title__breaker">
        <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" />
        </svg>
      </div>

      <div class="kb-stafet-flow-title__description">
        <p class="kb-stafet-flow-title__description-text">{{ userInfo ? getLabel('editDescription') :
          getLabel('description') }}</p>
      </div>

    </article>

    <section class="kb-cta-box-checkbox">
      <div class="kb-cta-box-checkbox__box-content-container">
        <div class="kb-cta-box-checkbox__box-content">
          <div class="kb-cta-box-checkbox__box-circle">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40">
              <path fill="#283F3E" d="M19.344 15.81a1.27 1.27 0 1 0 0-2.54 1.27 1.27 0 0 0 0 2.54Z" />
              <path fill="#283F3E"
                d="M19.343 2.665A17.335 17.335 0 1 0 36.678 20 17.354 17.354 0 0 0 19.343 2.665Zm0 33.275A15.94 15.94 0 1 1 35.283 20a15.954 15.954 0 0 1-15.94 15.94Z" />
              <path fill="#283F3E"
                d="M31.36 12.205A14.372 14.372 0 0 0 6.6 13.26l1.233.652a12.977 12.977 0 1 1 8.734 18.772C9.69 31.204 5.35 24.93 6.428 18.214l1.82.39.293-1.362-3.2-.693-.15.684c-1.66 7.734 3.205 15.12 11.09 16.814 1 .216 2.021.325 3.046.325a14.367 14.367 0 0 0 12.032-22.167Z" />
              <path fill="#283F3E" d="M16.238 25.572v1.396h6.717v-1.396h-2.66v-8.59h-3.703v1.395h2.307v7.195h-2.66Z" />
            </svg>
          </div>
          <div>
            <h2 class="kb-cta-box-checkbox__box-title">{{ getLabel('ctaTitle') }}</h2>
            <p class="kb-cta-box-checkbox__box-description">{{ getLabel('ctaDescription') }}</p>
          </div>
        </div>

      </div>
    </section>

    <article class="kb-stafet-step kb-optimizely-forms">
      <h2 class="kb-stafet-step__title">{{ getLabel('eventDescriptionTitle') }}</h2>

      <FormInputTextField fieldName="nameOfEvent" :modelValue="nameOfEvent" v-model="nameOfEvent"
        :label="getLabel('nameOfEventLabel')" :isRequired="true"
        :isValidationError="showError('nameOfEvent', nameOfEvent)"
        :errorMessageLabel="getLabel('nameOfEventErrorLabel')" />

      <div class="Form__Element FormTextbox ValidationRequired"
        :class="{ 'kb-text-editor--error': showError('description', description) }">
        <label for="description" class="Form__Element__Caption">{{ getLabel('descriptionLabel') }}</label>
        <editor v-if="editorReady" :init='{
          plugins: "emoticons autoresize lists autolink",
          toolbar: "emoticons bold italic underline bullist numlist",
          toolbar_location: "bottom",
          menubar: false,
          statusbar: false,
          valid_elements: "a[href|target],strong,em,u,ul,ol,li,p,br",
          formats: {
                bold: { inline: "strong" },
                italic: { inline: "em" },
                underline: { inline: "u" }
            },
          paste_webkit_styles: "none",
          paste_remove_styles: true,
          paste_remove_spans: true
        }' v-model="description">
        </editor>
        <div aria-live="assertive">
          <p v-if="showError('description', description)" class="kb-forms Form__Element__ValidationError" role="alert">
            {{ getLabel('descriptionErrorLabel') }}</p>
        </div>
      </div>
      <FormCheckbox fieldName="shareInMainCalendar" :modelValue="shareInMainCalendar.toString()"
        v-model="shareInMainCalendar" :label="getLabel('shareInMainCalendarLabel')"
        :onChangeCallback="(e) => shareInMainCalendar = e.target.checked" />

      <FormCheckbox v-if="shareInMainCalendar" fieldName="mandatoryRegistration"
        :modelValue="mandatoryRegistration.toString()" v-model="mandatoryRegistration"
        :label="getLabel('mandatoryRegistrationLabel')"
        :onChangeCallback="(e) => mandatoryRegistration = e.target.checked" />

      <FormInputTextField v-if="shareInMainCalendar" fieldName="maxParticipants" type="number"
        :modelValue="maxParticipants?.toString()" v-model="maxParticipants" :label="getLabel('maxParticipantsLabel')"
        :isValidationError="showError('maxParticipants', maxParticipants)"
        :errorMessageLabel="getLabel('maxParticipantsErrorLabel')" />

      <hr class="kb-stafet-step__breaker-line" />

      <h2 class="kb-stafet-step__title">{{ getLabel('DateTimeTitle') }}</h2>

      <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
        <FormInputTextField fieldName="startDate" type="date" :modelValue="startDate" v-model="startDate"
          :label="getLabel('startDateLabel')" :isRequired="true" :isValidationError="isStartDateValid"
          :errorMessageLabel="getLabel('startDateErrorLabel')" />

        <FormInputTextField fieldName="startTime" type="time" :modelValue="startTime" v-model="startTime"
          :label="getLabel('startTimeLabel')" :isRequired="true" :isValidationError="showError('startTime', startTime)"
          :errorMessageLabel="getLabel('startTimeErrorLabel')" />
      </div>

      <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
        <FormInputTextField fieldName="endDate" type="date" :modelValue="endDate" v-model="endDate"
          :label="getLabel('endDateLabel')" :isRequired="true" :isValidationError="isEndDateValid"
          :errorMessageLabel="getLabel('endDateErrorLabel')" />

        <FormInputTextField fieldName="endTime" type="time" :modelValue="endTime" v-model="endTime"
          :label="getLabel('endTimeLabel')" :isRequired="true" :isValidationError="showError('endTime', endTime)"
          :errorMessageLabel="getLabel('endTimeErrorLabel')" />
      </div>

      <hr class="kb-stafet-step__breaker-line" />

      <h2 class="kb-stafet-step__title">{{ getLabel('addressTitle') }}</h2>

      <FormAddressField v-model:address-line-value="address" v-model:zip-code-value="postalCode"
        v-model:city-value="city" :addressLabel="getLabel('addressLabel')" :zipCodeLabel="getLabel('zipCodeLabel')"
        :addressPlaceholder="getLabel('addressPlaceholderLabel')"
        :zipCodePlaceholder="getLabel('zipCodePlaceholderLabel')" :cityPlaceholder="getLabel('cityLabel')"
        :cityLabel="getLabel('cityPlaceholderLabel')" :isValidationError="showErrorAddress"
        :errorMessageLabel="getLabel('addressErrorLabel')" />

      <hr class="kb-stafet-step__breaker-line" />

      <h2 class="kb-stafet-step__title">{{ getLabel('contactPersonTitle') }}</h2>

      <FormRadioGroup :radioOptions="contactTypeRadioOptions" v-model="contactType" fieldName="contactType"
        v-on:change="updateContactType($event.target.value)" v-if="!isEditContext" />

      <div v-if="isEditContext || !contactPersonMyself">
        <FormInputTextField fieldName="contactPersonName" type="text" :modelValue="contactPersonName"
          v-model="contactPersonName" :label="getLabel('contactPersonNameLabel')" :isRequired="true"
          :isValidationError="showError('contactPersonName', contactPersonName)"
          :errorMessageLabel="getLabel('contactPersonNameErrorLabel')" />

        <FormInputTextField fieldName="contactPersonEmail" type="email" :modelValue="contactPersonEmail"
          v-model="contactPersonEmail" :label="getLabel('contactPersonEmailLabel')" :isRequired="true"
          :isValidationError="showError('contactPersonEmail', contactPersonEmail)"
          :errorMessageLabel="getLabel('contactPersonEmailErrorLabel')" />

        <FormInputTextField fieldName="contactPersonPhone" type="phone" :modelValue="contactPersonPhone"
          v-model="contactPersonPhone" :label="getLabel('contactPersonPhoneLabel')" :isRequired="false"
          :isValidationError="showError('contactPersonPhone', contactPersonPhone)"
          :errorMessageLabel="getLabel('contactPersonPhoneErrorLabel')" />
      </div>

      <article class="kb-stafet-flow-actions">
        <div class="kb-stafet-flow-actions__buttons-wrapper">
          <button class="kb-button kb-button--full-color-spot kb-button--full-color-spot" :class="{
            'kb-button--disabled': showSpinner
          }" v-on:click="submit">
            {{ getLabel('submitButtonText') }}
          </button>
        </div>

        <div v-if="showSpinner" class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner"></div>
        </div>
      </article>

    </article>
  </article>
</template>
